import React, {useEffect,useState,useContext} from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom'
import { ContentContainer,ContentGroup,Detail,ListItem } from 'coaz-ui'
import { PiBookLight, PiStarLight, PiUserLight } from 'react-icons/pi'
import client from '../client'
import { GlobalContext } from '../contexts/GlobalContext';
import { PiTextAlignLeftLight } from 'react-icons/pi'
import ContentColumn from './ContentColumn'
import ContentRow from './ContentRow'
import ContentRowItem from './ContentRowItem'

const CpdStudent = () => {
	const [student,setStudent] = useState(null);
	const [topics,setTopics] = useState([]);
	const [loading,setLoading] = useState(true);
	const { programId,cpdId,topicId } = useParams();
	const path = useLocation().pathname;
	const {version,setVersion} = useContext(GlobalContext);

	const {request,getCurrent} = client;

	const getStudent = async () => {
		if(!programId || !cpdId) return;

		let curr = null;

		try {
			curr = await getCurrent();
		} catch(error) {
			console.log(error)
		}

		if(!curr || !curr.user) 
			return;

		try {
			const response = await request("GET","cpd-students",null,{
				userReference:curr.user.ref.value,
				programId:programId,
				cpdId:cpdId
			})

			if(response) {
				setStudent(response)
			} else {
				setStudent(null)
			}
		} catch(error) {
			setStudent(null)
		}
	}

	const getTopics = async () => {
		try {
			const response = await request("GET","topics/by-cpd",null,{cpdId:cpdId})

			if(response && response.length > 0) {
				setTopics(response)
			} else {
				setTopics([])
			}
		} catch(error) {
			setTopics([])
		}
	}

	const navigate = useNavigate();

	const onOpenTopic = (item) => {
		if(!item || !item.id || !student || !student.teacher) return;
		
		navigate(`${path}/_topic/${item.id}/${student.teacher.user.ref.id}`)
	}

	const load = async () => {
		setLoading(true);
		await getStudent();
		await getTopics();
		setLoading(false);
	}

	useEffect(() => {
		load();
	},[version])

	if(topicId) 
		return (
			<Outlet/>
	)
  return (
	<ContentContainer
		Icon={PiBookLight}
		text={`${student?.cpd?.name ?? ""}`}
		scrollable={true}
		loading={loading}
	>
		{student  && student.cpd && student.student.user &&
		<ContentColumn>
			<ContentRow>
				<ContentRowItem title="Details">
					<div className="flex flex-col w-full h-auto p-2 space-y-2">
						<Detail
							Icon={PiBookLight}
							label="Cpd"
							value={student.cpd.name}
						/>
						<Detail
							Icon={PiUserLight}
							label="User"
							value={`${student.student.user.firstname} ${student.student.user.lastname}`}
						/>
						<Detail
							Icon={PiStarLight}
							label="Points"
							value={student.cpd.points}
						/>
					</div>
				</ContentRowItem>
			</ContentRow>
			<ContentRow>
				{topics.length > 0 && (
					<ContentRowItem title="Topics">
						<div className='flex flex-col space-y-2 p-2'>
						{topics.map((topic, i) => (
							<ListItem
								key={topic.ref?.id ?? topic.id ?? i}
								Icon={PiTextAlignLeftLight}
								item={{
									id: topic.ref?.id ?? topic.id,
									text: topic.name,
								}}
								handleOpen={onOpenTopic}
							/>
						))}
						</div>
					</ContentRowItem>
				)}
			</ContentRow>
		</ContentColumn>
		}
	</ContentContainer>
  )
}

export default CpdStudent